export default __webpack_public_path__ + "static/media/25.6d173ba0.jpg";